import {
  ADD_ENTRY,
  REMOVE_ENTRY,
  EDIT_ENTRY,
  SET_ENTRIES,
} from '../actions/entryActions';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_ENTRY:
      return [
        action.entry, ...state, 
      ];
    case EDIT_ENTRY:
      return state.map((entry) => {
        if (entry.id === action.id) {
          return {
            ...entry,
            ...action.updates
          };
        }
        return entry;
      });
    case SET_ENTRIES:
      return action.entries;
    case REMOVE_ENTRY:
      return state.filter((entry) => {
        return entry.id !== action.id;
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/entriesReducer.js